import {
  CIRCLE_ELEMENTS,
  CLASSES_FOCUSED,
  ID_NAME_MODAL_TALENT,
  ID_NAME_PLAYER_CONTROL,
  ID_NAME_SECONDLEVEL,
  ID_NAME_SUPERDESTACADOS,
  ID_NAME_VCARD_OPTIONS,
  ID_NAME_LO_MAS_VISTO,
  ID_MODAL_FILTER_BUTTON,
  ID_NAME_SEASON_TEMP,
  CLASSES_EXCLUDED,
  ID_NAME_CARD_VERTICAL,
  STYLEFILTERBUTTON,
  COLORFILTERBUTTON,
  ID_NAME_CARD_PERSONAJES,
  ID_NAME_CARD_TALENTS,
  ID_NAME_PLAN_SELECTOR_ITEM,
  ID_NAME_SEARCH_VERTICAL,
  ID_NAME_SEARCH_HORIZONTAL,
  ID_NAME_SEARCH_TALENTS,
  CLASS_NAME_MULTI_IMAGE,
  ID_NAME_VCARD_OPTIONS_YELLOW,
  ID_NAME_CARD_CLASSIC,
  ID_NAME_CARD_RECORDINGS,
  ID_PROFILE_AVATAR_IMAGE,
  ID_NAME_FILTER_LIVE_BUTTONS,
  ID_NAME_CARD_CHANNEL_CATEGORY,
  ID_NAME_CARD_MUSIC_RIBBONS,
  ID_VCARD_EPISODES,
  ID_VCARD_RECOMENDATIONS, CLASS_NAME_OUTLINE_FOCUS,
} from "./constants";
import store from "src/store";
import Metadata from "../../requests/apa/Metadata";
import DeviceStorage from "../DeviceStorage/DeviceStorage";

const isMultipleImage = (evt: HTMLElement) => {
  return  evt.querySelector(`.${CLASS_NAME_MULTI_IMAGE}`);
}

export const getElements = (evt: HTMLElement) => {
  const imageContainer = evt.querySelector('.container-card-cover')
  const imageContainerAvatar = evt.id === ID_PROFILE_AVATAR_IMAGE ? evt.querySelector('img') : null;
  const isMultipleImageMusic = isMultipleImage(evt);
  const image = imageContainer && !isMultipleImageMusic ? imageContainer.querySelector('img') : isMultipleImageMusic;
  const coverImage = evt.querySelector('.card-cover');
  const mask = document.querySelector('.focus-container');
  const target = coverImage || image || imageContainerAvatar || evt;
  const ribbonHighlight = evt.querySelector('.card-highlight');

  return {
    imageContainer,
    image,
    coverImage,
    mask,
    target,
    ribbonHighlight
  };
};

export const isExcludedElement = (evt: HTMLElement) => {
  let excludedElement = false;
  if (evt) {
    for (let index = 0; index < CLASSES_EXCLUDED.length; index++) {
      if (evt.classList.contains(CLASSES_EXCLUDED[index])) {
        excludedElement = true;
      }
    }
  }
  return excludedElement;
}

export const reviewActiveElement = () => {
  const result = Array.from(document.querySelectorAll(CLASSES_FOCUSED));
  let activeElement = false;
  for (let i = 0; i < result.length; i++) {
    if (result[i] === document.activeElement) {
      activeElement = true;
    }
  }
  return activeElement
}

export const getElementsCircle = () => {
  const ribbonCircle = Array.from(document.querySelectorAll(CIRCLE_ELEMENTS));
  let activeElement = reviewActiveElement();
  let activeElementCircle = false;

  for (let i = 0; i < ribbonCircle.length; i++) {
    if (ribbonCircle[i] === document.activeElement) {
      activeElementCircle = true;
    }
  }

  return {activeElement, activeElementCircle};
};

const validateMusicNode = () => {
  const location = window.location.toString();
  const validation = location.indexOf("claromusica") !== -1;
  return validation;
}

export const getValuesWidthAndHeight = (evt: HTMLElement, ribbonHighlight: HTMLElement, target: HTMLElement) => {

  const id = evt.id;
  const { width = 0, height = 0 } = target.getBoundingClientRect();
  let widthElement = width;
  let heightElement = height;
  const isMusicNode = validateMusicNode();

  switch (true) {
    case id.includes(ID_NAME_VCARD_OPTIONS_YELLOW):
      widthElement = width - 12;
      heightElement = height;
      break;
    case id.includes(ID_NAME_MODAL_TALENT):
      widthElement = width + 6;
      heightElement = height + 6;
      break;
    case id.includes(ID_NAME_SUPERDESTACADOS):
      widthElement = isMusicNode ? width - 27 : width - 4;
      heightElement = isMusicNode ? height - 1 : height + 1;
      break;
    case id.includes(ID_NAME_SECONDLEVEL):
      widthElement = width + 16;
      heightElement = height + 11;
      break;
    case id.includes(ID_NAME_PLAYER_CONTROL):
      widthElement = width;
      heightElement = height;
      break;
    case id.includes(ID_NAME_LO_MAS_VISTO):
      widthElement = width + 17;
      heightElement = height + 13;
      break;
    case id.includes(ID_MODAL_FILTER_BUTTON):
      widthElement = width - 6;
      heightElement = height + 7;
      break;
    case id.includes(ID_NAME_SEASON_TEMP):
      widthElement = width + 10;
      heightElement = height;
      break;
    case id.includes(ID_NAME_CARD_VERTICAL):
      widthElement = width + 8;
      heightElement = height + 11;
      break;
    case id.includes(ID_NAME_CARD_PERSONAJES) || id.includes(ID_NAME_CARD_TALENTS):
      widthElement = width + 8;
      heightElement = height + 8;
      break;
    case id.includes(ID_NAME_PLAN_SELECTOR_ITEM):
      widthElement = width - 5;
      heightElement = height - 5;
      break;
    case id.includes(ID_PROFILE_AVATAR_IMAGE):
      widthElement = width ;
      heightElement = height - 2;
      break;
    case id.includes(ID_NAME_CARD_MUSIC_RIBBONS):
      widthElement = width + 4;
      heightElement = height + 2;
      break;
    case id.includes(ID_VCARD_EPISODES) || id.includes(ID_VCARD_RECOMENDATIONS) || id.includes(ID_NAME_CARD_CLASSIC):
      widthElement = width + 6;
      heightElement = height + 5;
      break;
    case id.includes(ID_NAME_SEARCH_TALENTS):
      widthElement = width + 3.5;
      heightElement = height + 3.5;
      break;
    case id.includes(ID_NAME_SEARCH_HORIZONTAL):
      widthElement = width + 7;
      heightElement = height + 11;
      break;
    case id.includes(ID_NAME_SEARCH_VERTICAL):
      widthElement = width + 7;
      heightElement = height + 9;
      break;
    case id.includes(ID_NAME_CARD_CHANNEL_CATEGORY):
      widthElement = width - 4;
      heightElement = height;
      break;
    case id.includes(ID_NAME_FILTER_LIVE_BUTTONS):
      widthElement = width - 5;
      heightElement = height + 4;
      break;
    case id.includes(ID_NAME_CARD_RECORDINGS):
      widthElement = width + 6;
      heightElement = height + 5;
      break;
    default:
      widthElement = width + 8;
      heightElement = height + 9;
      break;
  }

  return { widthElement, heightElement };
}

export const getExtraValues = (evt: HTMLElement, direction: string) => {
  const id = evt.id;
  let extraTop = 0;
  let extraLeft = 0;
  const isMusicNode = validateMusicNode();

  switch (true) {
    case id.includes(ID_NAME_VCARD_OPTIONS_YELLOW):
      extraLeft = 3;
      extraTop = -3;
      break;
    case id.includes(ID_NAME_MODAL_TALENT):
      extraLeft = -6;
      extraTop = -6;
      break;
    case id.includes(ID_NAME_SECONDLEVEL):
      extraLeft = -9;
      extraTop = -8;
      break;
    case id.includes(ID_NAME_PLAYER_CONTROL):
      extraLeft = -3;
      extraTop = -3;
      break;
    case id.includes(ID_NAME_LO_MAS_VISTO):
      extraLeft = -15;
      extraTop = -7;
      break;
    case id.includes(ID_NAME_SUPERDESTACADOS):
      extraLeft = isMusicNode ? 7 : -4;
      extraTop = isMusicNode ? -7 : -7;
      break;
    case id.includes(ID_MODAL_FILTER_BUTTON):
      extraLeft = 0;
      extraTop = -6;
      break
    case id.includes(ID_NAME_SEASON_TEMP):
      extraLeft = -9;
      extraTop = -3;
      break;
    case id.includes(ID_NAME_PLAN_SELECTOR_ITEM):
      extraTop = 0;
      extraLeft = 0;
      break;
    case id.includes(ID_PROFILE_AVATAR_IMAGE):
      extraLeft = -3;
      extraTop = -2;
      break;
    case id.includes(ID_NAME_CARD_MUSIC_RIBBONS):
      extraTop = -3;
      extraLeft = -5;
      break;
    case id.includes(ID_VCARD_EPISODES) || id.includes(ID_VCARD_RECOMENDATIONS) || id.includes(ID_NAME_CARD_CLASSIC):
      extraTop = -6;
      extraLeft = -6;
      break;
    case id.includes(ID_NAME_SEARCH_TALENTS):
      extraTop = -4;
      extraLeft = -4;
      break;
    case id.includes(ID_NAME_FILTER_LIVE_BUTTONS):
      extraTop = -5;
      extraLeft = 0;
      break;
    case id.includes(ID_NAME_CARD_CHANNEL_CATEGORY):
      extraLeft = -1;
      extraTop = -3;
      break;
    case id.includes(ID_NAME_SEARCH_VERTICAL):
    case id.includes(ID_NAME_SEARCH_HORIZONTAL):
      extraTop = -6;
      extraLeft = -4;
      break;
    case id.includes(ID_NAME_CARD_RECORDINGS):
      extraTop = -6;
      extraLeft = -10;
      break;
    default:
      extraTop = -8;
      extraLeft = -7;
      break;
  }
  return {
    extraTop,
    extraLeft,
  };
};

const getScaledValues = (evt: HTMLElement) => {
  const id= evt.id
  let value = 'scale(1.03, 1.03)';

    switch (true) {
      case id.includes(ID_NAME_VCARD_OPTIONS_YELLOW):
      case id.includes(ID_NAME_VCARD_OPTIONS):
        value = 'scale(1.1, 1.1)';
        break;
      case id.includes(ID_NAME_PLAYER_CONTROL):
        value = "scale(1.15, 1.15)";
        break;
      default:
        break;
    }

    return value;
}

export const setRedColorButton = (evt: any) => {
  if(evt && evt.id && evt.id.includes(STYLEFILTERBUTTON)){
    evt.style.backgroundColor = COLORFILTERBUTTON;
  }
};

export const transformMask = (
    mask: HTMLElement,
    validateElement: boolean,
    target: HTMLElement,
    extraTop: number,
    extraLeft: number,
    widthElement: number,
    heightElement: number,
    activeElementCircle: boolean,
) => {
    const {player: { isLive = false, playerstate = "STOPPING" }} = store.getState();
    const showPlayer = !isLive && playerstate === 'PLAYING' && target.id.includes(ID_NAME_VCARD_OPTIONS);
    mask.style.display = showPlayer ? 'none' : 'block';
    mask.style.top = `${target.getBoundingClientRect().top + extraTop}px`;
    mask.style.left = `${target.getBoundingClientRect().left + extraLeft}px`;
    mask.style.width = `${widthElement}px`;
    mask.style.height = `${heightElement}px`;
    mask.style.transform = getScaledValues(target);
    mask.style.borderRadius = activeElementCircle ? '50%' : '5px';
    mask.style.zIndex = '10000000000000';
    mask.style.border = validateElement ? '3px solid #FFFFFF' : 'transparent';
    mask.style.pointerEvents = 'none';
};


export const removeDynamicFocus = () => {
  const maskFocus = document.querySelector(".focus-container")
  if(maskFocus) maskFocus.style.display = "none";

}

export const isActiveFocusDynamic = () => {
  const region = DeviceStorage.getItem('region');
  const isEnable = Metadata.get('enable_foco', '{}');

  const getValueKey = JSON.parse(isEnable)
  const valueEnable = getValueKey[region] ? getValueKey[region].enable : (getValueKey["default"] ? getValueKey["default"].enable : false);

  return valueEnable;
}

export const applyOutLineFocus = () => {
  return isActiveFocusDynamic() ? CLASS_NAME_OUTLINE_FOCUS : "";
}



// WEBPACK FOOTER //
// ./src/components/Focus/utils.ts